import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
};

export const fetchSaveprofileList = createAsyncThunk(
    "fetchSaveprofileList",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/user/save-profile-list?page=${body.page}&search=${body.search}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);


export const SaveProfileSlice = createSlice({
    name: "SaveProfileSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchSaveprofileList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(fetchSaveprofileList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(fetchSaveprofileList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default SaveProfileSlice.reducer;
